<template>
  <div class="quiz-nav">
    <div class="quiz-nav__progress">
      <Bullets :bullets="bullets" hint></Bullets>
    </div>

    <Button class="quiz-nav__next" @click="next" :class="answered ? 'visible' : ''">
      {{ isLastStep ? 'Узнать результат' : 'Следующий вопрос' }}
    </Button>
  </div>
</template>

<script>
  import Bullets from '@/components/Quiz/Bullets.vue'

  export default {
    components: { Bullets },
    computed: {
      bullets () {
        return this.$store.getters.bullets
      },
      answered () {
        return this.$store.getters.answered
      },
      isQuizMiddle () {
        return this.$store.getters.isQuizMiddle
      },
      isLastStep () {
        return this.$store.getters.isLastStep
      }
    },
    methods: {
      next () {
        const { pushEvent, events } = this.$metrics
        if (this.isQuizMiddle) pushEvent(events.CLICK_CONTINUE_QUIZ_MIDDLE)
        if (this.isLastStep) pushEvent(events.CLICK_SHOW_RESULTS)
        this.$store.dispatch('next')
      }
    }
  }
</script>

<style lang="scss">
  .quiz-nav {
    text-align: center;
  }

  .quiz-nav__next {
    margin-top: 20px;
    visibility: hidden;
    opacity:0;
    transition: 0.5s opacity;
    @include mq(mobile) {
      margin-top: 15px;
    }

    &.visible {
      opacity: 1;
      visibility: visible;
    }
  }
</style>
